import React from 'react';
import { AvatarProps } from './avatar.interface';
import { Avatar } from 'primereact/avatar';

const AvatarC = (props: AvatarProps) => {
  const { image, size, shape, className, icon, label } = props;
  return (
    <Avatar
      image={image}
      size={size}
      shape={shape}
      className={className}
      icon={icon}
      label={label}
    />
  );
};

export default React.memo(AvatarC);
